import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../services/http.service';
import { Language } from './language.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class LanguageApiService {
  constructor(private http: HttpService) {}

  public getLoginLanguages(): Observable<string[]> {
    const url = `${apiBaseUrl}/v1/iam/languages/login`;

    return this.http.get(url);
  }

  public getLanguages(): Observable<Language[]> {
    const url = `${apiBaseUrl}/v1/iam/languages`;

    return this.http.get(url);
  }

  public getOrganizationLanguages(organizationUId: string): Observable<Language[]> {
    const url = `${apiBaseUrl}/v1/iam/languages/${organizationUId}`;

    return this.http.get(url);
  }
}
